var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-overlay',{attrs:{"value":this.$store.state.isLoading}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":70,"width":7}})],1),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }